import { ConsumerViewPage } from '@page/consumer-view/consumer-view.page';
import { ConsumersPage } from '@page/consumers/consumers.page';

import { NavigationAside } from '@component/aside/navigation/navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const ConsumerRoutes: RouteConfigInterface[] = [
  {
    Header,
    Aside: NavigationAside,
    Component: ConsumersPage,
    ...pageNameLoader(RouteEnum.Consumers),
  },
  {
    Header,
    Aside: NavigationAside,
    Component: ConsumerViewPage,
    ...pageNameLoader(RouteEnum.ConsumerView),
  },
  {
    Header,
    Aside: NavigationAside,
    Component: ConsumerViewPage,
    ...pageNameLoader(RouteEnum.ConsumerServiceView),
  },
];
